export default __webpack_public_path__ + "static/media/error.321bd00c.png";